import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import INVOICE_STATUS from "../../../../constants/invoice-status";

const InvoiceWarnings = memo(({
    existingDraftInvoice,
    previousInvoices = [],
    projectId,
    isRejectedInvoice = false,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    // If this is a rejected invoice workflow, don't show warnings or continue button
    if (isRejectedInvoice) {
        return null;
    }

    // Find any incomplete invoice (any invoice that is not FINALIZED or REJECTED)
    const incompleteInvoice = existingDraftInvoice ||
        previousInvoices.find(invoice =>
            invoice.status !== INVOICE_STATUS.REJECTED &&
            invoice.status !== INVOICE_STATUS.FINALIZED
        );

    if (incompleteInvoice) {
        return (
            <div className="alert alert-warning mt-3">
                <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                {t("invoice.incomplete-invoice-warning")}
                <div className="mt-2 small">
                    {t("invoice.invoice-number")}: <strong>{incompleteInvoice.invoiceNumber}</strong> -
                    <button
                        className="btn btn-link btn-sm p-0 ms-2"
                        onClick={() => navigate(`/projects/${projectId}/invoice-v2/edit/${incompleteInvoice.id}`)}
                    >
                        {t("invoice.continue")}
                    </button>
                </div>
            </div>
        );
    }

    // In stepper workflow, just return null - warnings are handled above
    // Footer navigation buttons handle progression
    return null;
});

InvoiceWarnings.displayName = "InvoiceWarnings";

export default InvoiceWarnings;
